import errorHandler from './errorHandler';
import responseHandler from './responseHandler';

export default function responseInterceptor(axiosClientInterceptor) {
  axiosClientInterceptor.use(responseHandler, errorHandler);
}
